{
  "CxiLicenceType_SOLO": "Solo",
  "CxiLicenceType_TEAMS": "Équipes",
  "CxiLicenceType_UNITE": "Unir",
  "CxiLicenceType_NONE": "Aucun",
  "NAME": "CxiLicenceTypes"
}